<template>
  <div class="spin">
    <img class="spin-pan" src="../assets/common/spin.png" />
  </div>
</template>

<script>
export default {}
</script>

<style lang="less" scoped>
.spin {
  width: 44px;
  height: 44px;
  position: relative;
  &-pan {
    width: 44px;
    height: 44px;
    animation: rotate 1.5s linear infinite forwards;
    animation-fill-mode: forwards;
  }
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
